(() => {
  const init = () => {
    const article = document.querySelector('.article-template__content');
    if (!article) return;

    const images = [...article.querySelectorAll('img')];
    if (!images.length) return;

    const overlay = document.createElement('div');
    overlay.className = 'jr-blog-lightbox';
    overlay.hidden = true;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Enlarged article image');

    const enlarged = document.createElement('img');
    enlarged.className = 'jr-blog-lightbox__image';
    enlarged.alt = '';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'jr-blog-lightbox__close';
    closeButton.setAttribute('aria-label', 'Close enlarged image');
    closeButton.textContent = '×';

    overlay.append(enlarged, closeButton);
    document.body.append(overlay);

    let previousFocus = null;
    let previousOverflow = '';

    const close = () => {
      overlay.hidden = true;
      document.documentElement.classList.remove('jr-blog-lightbox-open');
      document.documentElement.style.overflow = previousOverflow;
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    const open = (image, href) => {
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      enlarged.src = href || image.currentSrc || image.src;
      enlarged.alt = image.alt || 'Enlarged article image';
      overlay.hidden = false;
      document.documentElement.classList.add('jr-blog-lightbox-open');
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    };

    images.forEach((image) => {
      const link = image.closest('a');
      if (link) {
        link.removeAttribute('target');
        link.removeAttribute('rel');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          open(image, link.href);
        });
      } else {
        image.tabIndex = 0;
        image.setAttribute('role', 'button');
        image.addEventListener('click', () => open(image));
        image.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            open(image);
          }
        });
      }
    });

    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) close();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();